import { PushAction } from 'redux-little-router';
import { combineEpics, Epic } from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';

import { Action } from '../../actions';
import { changeLocation } from '../../actions/common';
import {
    GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER,
    GRID_NAVIGATION_GO_TO_FILTER,
    GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL,
    GridNavigationGoToAdditionalFilterAction,
    GridNavigationGoToFilterAction,
    GridNavigationGoToStatPeriodUrlAction
} from '../../actions/grid-navigation';
import {
    updateAdditionalFilter,
    UpdateGridFilterDict,
    updateGridFilterDict,
    updateGridFilterPeriod
} from '../../actions/grid-screen';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { serializeFilterToString, serializePeriodFilter } from '../../service/FilterHelpers/FilterHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers } from '../../service/UrlHelpers';
import { GridScreenUrlSearchQueryParams } from '../../typings/grid';
import { State } from '../../typings/state';

const gridScreenNavigationGoToFilterEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.ofType(GRID_NAVIGATION_GO_TO_FILTER).mergeMap((action: GridNavigationGoToFilterAction) => {
        const { router, grid } = store$.value;
        const { pathname, query = {} } = router;
        const state = store$.value;
        const sourceParams = selectGridSourceParams(state);
        let { filterDict } = grid;
        const serializedFilter = serializeFilterToString(action.expressions);
        let outAction$: Observable<UpdateGridFilterDict | PushAction> = EMPTY;

        if (sourceParams && filterDict) {
            const { view } = sourceParams;

            filterDict = {
                ...filterDict,
                [view]: serializedFilter
            };

            outAction$ = Observable.concat(outAction$, Observable.of(updateGridFilterDict(filterDict)));
        }

        if (serializedFilter !== query.filter) {
            outAction$ = Observable.concat(
                outAction$,
                Observable.of(
                    changeLocation(
                        pathname,
                        UrlHelpers.normalizeQuery({
                            [GridScreenUrlSearchQueryParams.filter]: serializedFilter
                        })
                    )
                )
            );
        }

        return outAction$;
    });
};

const gridScreenNavigationGoToAdditionalFilterEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$
        .ofType(GRID_NAVIGATION_GO_TO_ADDITIONAL_FILTER)
        .map((action: GridNavigationGoToAdditionalFilterAction) => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);

            const { view } = sourceParams;

            return updateAdditionalFilter(view, action.additionalFilter);
        });
};

const gridScreenNavigationGoToStatPeriodUrlEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.ofType(GRID_NAVIGATION_GO_TO_STAT_PERIOD_URL).mergeMap(
        (action: GridNavigationGoToStatPeriodUrlAction): Observable<Action> => {
            const {
                router: { pathname }
            } = store$.value;

            return Observable.concat(
                Observable.of(updateGridFilterPeriod(action.period)),
                Observable.of(changeLocation(pathname, UrlHelpers.normalizeQuery(serializePeriodFilter(action.period))))
            );
        }
    );
};

export const gridScreenNavigationEpic = combineEpics(
    gridScreenNavigationGoToFilterEpic,
    gridScreenNavigationGoToAdditionalFilterEpic,
    gridScreenNavigationGoToStatPeriodUrlEpic
);
